import React, { useState } from 'react'
import { isEmpty } from 'lodash'
import { Row, Col, Modal, ModalHeader, ModalBody, ModalFooter, Button } from 'reactstrap'
import { isMobile } from 'react-device-detect'
import CurrencyFormat from 'react-currency-format'
import ProductCardOptions from '../../Common/ProductCard/ProductCardOptions'
import { getUrlOfDefaultProductImage } from '../../../helpers/utils'
import currencyIcon from '../../../assets/images/currencydollar.png'
import ApiService from '../../../data/services/ApiService'

const routeSuppliersStorage = 'suppliers/'

function ProductDetail( props ) {
    const {
        code,
        product,
        showVariants,
        variants,
        firstVariantValue,
        secondVariantValue,
        thirdVariantValue,
        onChangeFirstVariant,
        onChangeSecondVariant,
        onChangeThirdVariant,
        quantity,
        onChangeQuantity,
        actionShareProductButton,
        shareProductText,
        addToCartButtonAction,
        addToCartButtonText,
        addToCartButtonDisabled,
        variantsDisabled,
        loading,
        stock,
    } = props

    const [priceModal, setPriceModal] = useState(false)
    const [profit, setProfit] = useState(0)
    const togglePriceModal = () => setPriceModal(!priceModal)

    const openModalPrice = () => {
        setProfit(product.retailPrice - product.wholeSalePrice)
        togglePriceModal()
    }

    return (
        <React.Fragment>
            <div className={"product-details"}>
                <h1 className="product-title">{product.name}</h1>

                <Row>
                    {product && product.wholeSalePrice && (
                        <Col className="text-left" style={{ paddingLeft: '0px', paddingRight: '0px' }}>
                            <div className="product-price">
                                <CurrencyFormat
                                    value={Math.round(product.wholeSalePrice)}
                                    displayType="text"
                                    decimalScale={2}
                                    thousandSeparator
                                    prefix="$"
                                />
                            </div>
                        </Col>
                    )}

                    {product && product.supplier && (
                        <Col className="text-right font-size-20" style={{ paddingLeft: '0px', paddingRight: '0px' }}>
                            <img
                                src={
                                    !isEmpty(product.supplier.logotipo)
                                        ? `${ApiService.getUrlBaseStorage()}${routeSuppliersStorage}${product.supplier.logotipo}`
                                        : getUrlOfDefaultProductImage()
                                }
                                alt=""
                                width="70px"
                                height="50px"
                                className="img-fluid mx-auto"
                            />
                        </Col>
                    )}
                </Row>

                <div>
                    <label className="product-price-retail">
                        <CurrencyFormat
                            value={Math.round(product.retailPrice)}
                            displayType="text"
                            decimalScale={2}
                            thousandSeparator
                            prefix="$"
                        />
                    </label> (<label style={{ textDecoration: 'underline', cursor: 'pointer' }} onClick={openModalPrice}>Precio Sugerido</label>) <img alt={``} style={{maxWidth: '20px'}} src={currencyIcon} />
                </div>

                {!isEmpty(code) && <div className="m-product-card-name">Código: {code}</div>}

                <div className="product-content">
                    <p style={{ fontSize: '0.9rem', fontWeight: 300, letterSpacing: 0, color: '#777' }}>
                        {product.description}
                    </p>
                </div>

                {showVariants && (
                    <ProductCardOptions
                        variants={variants}
                        firstVariantValue={firstVariantValue}
                        secondVariantValue={secondVariantValue}
                        thirdVariantValue={thirdVariantValue}
                        onChangeFirstVariant={onChangeFirstVariant}
                        onChangeSecondVariant={onChangeSecondVariant}
                        onChangeThirdVariant={onChangeThirdVariant}
                        quantity={quantity}
                        onChangeQuantity={onChangeQuantity}
                        disabled={variantsDisabled}
                        stock={stock}
                    />
                )}

                {!loading && !isMobile && (
                    <div style={{ display: 'flex', textAlign: 'center', marginTop: '20px' }}>
                        <button
                            style={{ width: '95%', cursor: 'pointer', border: '1px solid grey', marginRight: '5px' }}
                            disabled={addToCartButtonDisabled}
                            onClick={addToCartButtonAction}
                            className={`btn btn-default waves-effect waves-light`}
                        >
                            <i className="bx bx-cart"></i> {addToCartButtonText}
                        </button>
                        <button
                            style={{ width: '95%', cursor: 'pointer' }}
                            onClick={actionShareProductButton}
                            className={`btn btn-whatsapp waves-effect waves-light`}
                        >
                            <i className="bx bxl-whatsapp"></i> {shareProductText}
                        </button>
                    </div>
                )}
            </div>
            <div>
                <Modal isOpen={priceModal} toggle={togglePriceModal}>
                    <ModalHeader toggle={togglePriceModal}>Precio sugerido</ModalHeader>
                    <ModalBody>
                        <p>
                            <CurrencyFormat
                                value={profit}
                                displayType="text"
                                decimalScale={2}
                                renderText={(value) => `Tu posible ganancia con este producto: ${value}` }
                                thousandSeparator
                                prefix="$"
                            />
                        </p>
                        <p>El precio sugerido es el precio que Vendora te recomienda que vendas este producto a tus clientes.</p>
                        <p>Sin embargo, considera que tú eres libre de definir el precio final y puedes decidirlo: </p>
                        <ul>
                            <li>
                                Más arriba del precio sugerido para tener mas ganancia
                            </li>
                            <li>
                                o un poco más abajo como herramienta de negociación, en caso de vender varios productos o si quieres asegurarte que la venta se cierre.
                            </li>
                        </ul>
                        <p>En Vendora nuestra misión es que tú ganes bien, y que tu negocio crezca junto contigo.</p>
                    </ModalBody>
                    <ModalFooter>
                        <Button color="primary" className="btn btn-success waves-effect waves-light mb-2 mr-2" onClick={togglePriceModal}>Entendido</Button>
                    </ModalFooter>
                </Modal>
            </div>
        </React.Fragment>
    )
}

export default ProductDetail
